import * as React from 'react'
import { Icon } from '../../../../components/UI'
import { Styled } from './DownloadList.styled'
import { Kit } from './types'
import { useProductKitDownload } from '../../../../lib/hooks/useDownloadProductKit'

const renderDate = (date: string) => {
  // return string like 09 Mar 2022
  const dateObj = new Date(date)
  const month = dateObj.toLocaleString('default', { month: 'short' })
  const day = dateObj.getDate()
  const year = dateObj.getFullYear()
  return `${day} ${month} ${year}`
}

export const DownloadList = ({ kits, loading }: { kits?: Kit[]; loading: boolean }) => {
  if (!kits || loading) {
    return null
  }

  const { openDownload } = useProductKitDownload();


  return (
    <div>
      <Styled.Title>Product kit</Styled.Title>
      <Styled.List>
        {kits.map((kit, i) => (
          <Styled.Item key={`${kit.id}_${i}`}>
            <Styled.Content>
              <Styled.ItemTitle>{kit.description}</Styled.ItemTitle>
              <Styled.ItemDetails>
                <Styled.ItemDetail>{kit.fullVersion}</Styled.ItemDetail>
                <Styled.ItemDetail>{kit.fileSize}</Styled.ItemDetail>
                <Styled.ItemDetail>{renderDate(kit.fileDate)}</Styled.ItemDetail>
              </Styled.ItemDetails>
            </Styled.Content>
            <Styled.DownloadButton onClick={() => openDownload({ kit })} aria-label="Download">
              <Icon name="download" iconSize=".8rem" />
            </Styled.DownloadButton>
          </Styled.Item>
        ))}
      </Styled.List>
    </div>
  )
}
